<template>
  <div class="cmp-video">
    <video
      v-show="false"
      ref="myVideo"
      class="video"
      controls
      :src="itemData.url"
      @waiting="handleWaiting"
      @canplay="handleCanplay"
    >
      <!-- src="http://babylife.qiniudn.com/FtRVyPQHHocjVYjeJSrcwDkApTLQ" -->
      <!-- src="/singleMuseum/viewvedio_3486151319367951505314318568" -->
      <!-- <source src="https://www.runoob.com/try/demo_source/movie.ogg"> -->
    </video>

    <!-- <div class="mask hide" v-show="show" style="display:none">
      <van-icon class="btn-close" name="cross" @click="closeVideo"/>
      <video ref="myVideo" class="video" controls :src="itemData.url">
      </video>
    </div>-->
  </div>
</template>

<script>
// https://segmentfault.com/a/1190000019623347
// import { Icon } from 'vant'
export default {
  components: {
    // [Icon.name]: Icon
  },
  data() {
    return {
      itemData: {}
    }
  },
  methods: {
    init(item) {
      // this.$toast.loading({
      //   duration: 0, // 持续展示 toast
      //   forbidClick: true,
      //   loadingType: 'spinner',
      //   message: '加载中...'
      // })
      this.itemData = item

      // console.log(this.itemData)

      this.$refs.myVideo.load()

      this.$nextTick(() => {
        this.$refs.myVideo.play()
      })
    },
    handleWaiting() {},
    // 当浏览器可以播放视频时
    handleCanplay() {
      // this.$toast.clear()
    }
    // closeVideo() {
    //   this.$nextTick(() => {
    //     this.$refs.myVideo.pause()
    //   })
    //   this.itemData = {}
    //   this.show = false
    // }
  }
}
</script>

<style lang="scss" scoped>
.cmp-video {
  video {
    max-width: 100%;
  }
  // .mask {
  //   position: fixed;
  //   top: 0;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   z-index: 3;
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  //   background: #000;
  //   .btn-close {
  //     width: 44px;
  //     height: 44px;
  //     display: flex;
  //     justify-content: center;
  //     align-items: center;
  //     position: absolute;
  //     right: 5px;
  //     top: 5px;
  //     color: #e3e3e3;
  //     font-size: 20px;
  //   }
  //   video {
  //     max-width: 100%;
  //   }
  // }
}
</style>


